class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    clearTimeout(this.openTimer);
    this.cancelOpenFocus();
    this.openTimer = setTimeout(() => {
      this.openTimer = null;
      this.classList.add('animate', 'active');
      this.focusAfterOpen = () => {
        if (!this.classList.contains('active')) return;
        const container = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : this.querySelector('.drawer__inner');
        if (!container) return;
        const focusElement = container.contains(document.activeElement)
          ? document.activeElement
          : container.querySelector('.drawer__close') || container;
        trapFocus(container, focusElement);
        if (container.contains(document.activeElement)) this.cancelOpenFocus();
      };
      this.addEventListener('transitionend', this.focusAfterOpen);
      this.focusFrame = requestAnimationFrame(() => {
        this.focusFrame = requestAnimationFrame(() => {
          this.focusFrame = null;
          if (this.focusAfterOpen) this.focusAfterOpen();
        });
      });
      this.focusTimer = setTimeout(() => {
        this.focusTimer = null;
        if (this.focusAfterOpen) this.focusAfterOpen();
      }, 350);
    });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    clearTimeout(this.openTimer);
    this.openTimer = null;
    this.cancelOpenFocus();
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(this.activeElement);
  }

  cancelOpenFocus() {
    clearTimeout(this.focusTimer);
    cancelAnimationFrame(this.focusFrame);
    if (this.focusAfterOpen) this.removeEventListener('transitionend', this.focusAfterOpen);
    this.focusTimer = null;
    this.focusFrame = null;
    this.focusAfterOpen = null;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const sections = parsedState && parsedState.sections;
    const drawerHTML = sections && this.getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
    if (!drawerHTML) {
      window.location.assign(routes.cart_url);
      return;
    }
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const html = this.getSectionInnerHTML(sections[section.id], section.selector);
      if (sectionElement && html !== null) sectionElement.innerHTML = html;
    });
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (typeof html !== 'string' || !html.trim()) return null;
    const section = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return section ? section.innerHTML : null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

